import { api } from '@/lib/api'
import type { CompanyMember, AddMemberPayload, UpdateMemberPayload } from '@/types/company_member.types'

export const companyMemberService = {
  async list(companyId: string): Promise<CompanyMember[]> {
    const data = await api.get<{ members: CompanyMember[] }>(`/companies/${companyId}/members`)
    return data.members
  },

  async add(companyId: string, payload: AddMemberPayload): Promise<CompanyMember & { temp_password?: string }> {
    const data = await api.post<{ member: CompanyMember & { temp_password?: string } }>(`/companies/${companyId}/members`, payload)
    return data.member
  },

  async update(companyId: string, memberId: string, payload: UpdateMemberPayload): Promise<CompanyMember> {
    const data = await api.put<{ member: CompanyMember }>(`/companies/${companyId}/members/${memberId}`, payload)
    return data.member
  },

  async remove(companyId: string, memberId: string): Promise<void> {
    await api.delete(`/companies/${companyId}/members/${memberId}`)
  },

  async dispatchDailyTasksTest(companyId: string, memberId: string): Promise<{ success: boolean; data: Record<string, unknown> }> {
    return api.post<{ success: boolean; data: Record<string, unknown> }>(
      `/companies/${companyId}/members/${memberId}/dispatch-daily-tasks?force=true`,
      {}
    )
  },
}
